var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c(
          "c-card",
          {
            staticClass: "cardClassDetailInfo",
            attrs: { title: "유해위험기계기구 기본정보", collapsed: true },
          },
          [
            _c("template", { slot: "card-detail" }, [
              _vm.equipInfo.emplacementPlace
                ? _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-label-text", {
                        attrs: {
                          title: "설비위치",
                          value: _vm.equipInfo.emplacementPlace,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.equipInfo.machineryClassification
                ? _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-label-text", {
                        attrs: {
                          title: "설비종류",
                          value: _vm.equipInfo.machineryClassification,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.equipInfo.machineryName
                ? _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-label-text", {
                        attrs: {
                          title: "형식(규격)",
                          value: _vm.equipInfo.machineryName,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          2
        ),
        _c(
          "c-table",
          {
            ref: "table",
            attrs: {
              title: "유해위험기계기구 검사이력",
              tableId: "hazardEquipmentHis",
              columns: _vm.grid.columns,
              gridHeight: _vm.grid.height,
              data: _vm.tabParam.hazardEquipmentHistoryModels,
              usePaging: false,
              editable: _vm.editable,
              checkClickFlag: false,
              merge: _vm.grid.merge,
              selection: "multiple",
              rowKey: "inspectionId",
            },
          },
          [
            _c(
              "template",
              { slot: "table-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: {
                            label: "추가",
                            showLoading: false,
                            icon: "add",
                          },
                          on: { btnClicked: _vm.addItem },
                        })
                      : _vm._e(),
                    _vm.editable &&
                    _vm.tabParam.hazardEquipmentHistoryModels.length > 0
                      ? _c("c-btn", {
                          attrs: {
                            label: "삭제",
                            showLoading: false,
                            icon: "remove",
                          },
                          on: { btnClicked: _vm.removeItem },
                        })
                      : _vm._e(),
                    _vm.editable &&
                    _vm.tabParam.hazardEquipmentHistoryModels.length > 0
                      ? _c("c-btn", {
                          attrs: {
                            url: _vm.insertUrl,
                            isSubmit: _vm.isSave,
                            param: _vm.tabParam.hazardEquipmentHistoryModels,
                            mappingType: "POST",
                            label: "저장",
                            icon: "save",
                          },
                          on: {
                            beforeAction: _vm.saveHistory,
                            btnCallback: _vm.saveCallback,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }